import { createAction, props } from '@ngrx/store';
import { Ticket, TicketSearchRequest } from '../../../types/interfaces/ticket';
import {
  ChatMessage,
  MessageReactionsAttributes,
} from '../../../types/interfaces/message';
import {
  ChatNewManualConnectionRequest,
  MessageTemplate,
} from '../../../types/interfaces/message-templates';
import { ChatUserAttributes } from '../../../types/interfaces/chat-user';

export const initialTickets = createAction(
  '[Tickets] Initial Tickets',
  props<{ tickets: Ticket[] }>()
);

export const newTicket = createAction(
  '[Tickets] New Ticket',
  props<{ ticket: Ticket }>()
);

export const removeTicket = createAction(
  '[Tickets] Remove Ticket',
  props<{ ticketId: number }>()
);

export const updateTicket = createAction(
  '[Tickets] Update Ticket',
  props<{ ticket: Ticket }>()
);

export const ticketAssigned = createAction(
  '[Tickets] Ticket Assigned',
  props<{ ticket: Ticket }>()
);

export const selectTicket = createAction(
  '[Tickets] Select Ticket',
  props<{ ticket: Ticket | undefined }>()
);

export const selectTicketMessages = createAction(
  '[Tickets] Select Ticket Messages',
  props<{ chatId: number; messages: ChatMessage[] }>()
);

export const newMessage = createAction(
  '[Tickets] New ChatMessage',
  props<{ idTicket: number; message: ChatMessage }>()
);

export const updateMessage = createAction(
  '[Tickets] Update message',
  props<{ message: ChatMessage }>()
);

export const newAgentMessage = createAction(
  '[Tickets] New Agent ChatMessage',
  props<{ idTicket: number; message: ChatMessage }>()
);

export const removeAgentMessage = createAction(
  '[Tickets] Remove Rejected Agent ChatMessage',
  props<{
    ticketId: number;
    tempId: string;
    previousLastMessage?: ChatMessage;
  }>()
);

export const getMessageTemplatesForTicket = createAction(
  '[Tickets] Get Message Templates For Ticket',
  props<{ ticketId: number }>()
);

export const getMessageTemplatesForTicketSuccess = createAction(
  '[Tickets] Get Message Templates For Ticket Success',
  props<{ messageTemplates: MessageTemplate[] }>()
);

export const loadChatUsers = createAction(
  '[Tickets] Load Chat Users',
  props<{ filter?: string }>()
);

export const loadChatUsersSuccess = createAction(
  '[Tickets] Load Chat Users Success',
  props<{ users: ChatUserAttributes[] }>()
);

export const getMessageTemplates = createAction(
  '[Tickets] Get Message Templates',
  props<{ connectionId: string }>()
);

export const getMessageTemplatesSuccess = createAction(
  '[Tickets] Get Message Templates Success',
  props<{ messageTemplates: MessageTemplate[] }>()
);

export const createTicket = createAction(
  '[Tickets] Create Ticket',
  props<{ data: ChatNewManualConnectionRequest }>()
);

export const createTicketSuccess = createAction(
  '[Tickets] Create Ticket Success',
  props<{ result: any }>()
);

export const createTicketFailure = createAction(
  '[Tickets] Create Ticket Failure',
  props<{ message: string }>()
);

export const clearTicketCreated = createAction(
  '[Tickets] Clear Ticket Created'
);

export const getHistoryTickets = createAction(
  '[Tickets] Get History Tickets',
  props<{ params: TicketSearchRequest; append?: boolean }>()
);

export const getHistoryTicketsSuccess = createAction(
  '[Tickets] Get History Tickets Success',
  props<{ tickets: Ticket[]; append?: boolean; hasMore?: boolean }>()
);

export const clearSelectedTicket = createAction(
  '[Tickets] Clear Selected Ticket]'
);

export const newReaction = createAction(
  '[Tickets] New Reaction',
  props<{ idTicket: number; reaction: MessageReactionsAttributes }>()
);

export const markTicketAsRead = createAction(
  '[Tickets] Mark Ticket As Read',
  props<{ agentId: number; ticketId: number; lastMessageId: number }>()
);
